module.exports = __webpack_public_path__ + "media/images/achievement_category/learning_report_date_count-d083faae10f9e2431de3ecda444a32e6.png";